import React from "react";
import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: "Dashboard",
		url: "/dashboard",
		icon: "dashboard",
	},
	{
		name: "Services",
		url: "/services",
		icon: "wrench",
	},
];

export default class Service extends Framework.Components.View {
	render() {
		const breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/services/${this.props.match.params.id}`,
				icon: "edit",
			},
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history} />
				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Objects.Service
						id={this.props.match.params.id}
						locations={this.props.locations}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</Framework.Errors.General>
			</div>
		);
	}
}
